import type { AppVueRouter } from '@modules/core/services/router/types';
import {
  ADMIN_ARTICLES_ROUTE_NAME,
  AFFILIATE_ARTICLES_ROUTE_NAME,
  ARTICLES_PERMISSIONS,
} from '@modules/articles/constants';
import { AppModule } from '@modules/core/plugins/AppModule';

import {
  ADMIN_ARTICLES_VIEW_ROUTE_NAME,
  AFFILIATE_ARTICLES_VIEW_ROUTE_NAME,
} from './constants';

export class ArticlesViewModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(ADMIN_ARTICLES_ROUTE_NAME, {
      name: ADMIN_ARTICLES_VIEW_ROUTE_NAME,
      path: 'view/:id',
      permission: ARTICLES_PERMISSIONS.SHOW,
      component: () => import('./pages/ArticlesViewPage/ArticlesViewPage.vue'),
    });

    router.addChildRoute(AFFILIATE_ARTICLES_ROUTE_NAME, {
      name: AFFILIATE_ARTICLES_VIEW_ROUTE_NAME,
      path: 'view/:id',
      permission: ARTICLES_PERMISSIONS.SHOW,
      component: () => import('./pages/ArticlesViewPage/ArticlesViewPage.vue'),
    });
  }

  addMenu(): void {
  }

  addTranslationKeys(): void {
  }
}
